import { render, staticRenderFns } from "./btn-responsive-prop.vue?vue&type=template&id=226f8402&scoped=true"
import script from "./btn-responsive-prop.vue?vue&type=script&lang=js"
export * from "./btn-responsive-prop.vue?vue&type=script&lang=js"
import style0 from "./btn-responsive-prop.vue?vue&type=style&index=0&id=226f8402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f8402",
  null
  
)

export default component.exports